var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { ref } from "vue";
import { fetchFileSources } from "@/api/remoteFiles";
export const useFileSourcesStore = defineStore("fileSourcesStore", () => {
    const cachedFileSources = ref({});
    function getFileSources(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const cacheKey = getCacheKey(options);
            if (cachedFileSources.value[cacheKey] === undefined) {
                cachedFileSources.value[cacheKey] = fetchFileSources(options);
            }
            if (cachedFileSources.value[cacheKey] instanceof Promise) {
                cachedFileSources.value[cacheKey] = yield cachedFileSources.value[cacheKey];
            }
            return cachedFileSources.value[cacheKey];
        });
    }
    function getCacheKey(options) {
        return JSON.stringify(options);
    }
    return {
        getFileSources,
    };
});
